function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to handle scroll event
function onScroll() {
  var targetElement = document.querySelector(".scroll-section");
  if (isElementInViewport(targetElement)) {
    console.log('Element is in view!');
    var leftImage = document.querySelector(".scroll-section .left");
    var rightImage = document.querySelector(".scroll-section .right");
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var newTopPosition = 45 - scrollTop * 0.05 + '%';
    var newBottomPosition = 55 + scrollTop * 0.05 + '%';
    if (window.innerWidth < 768) { 
      newTopPosition = 30 - scrollTop * 0.05 + '%';
      newBottomPosition = 70 + scrollTop * 0.05 + '%';
    }
    console.log(newTopPosition);

    // Update the top position of the element
    if (leftImage) {
      leftImage.style.top = newTopPosition;
      leftImage.style.transform = 'translateY(-' + newTopPosition + ')';
    }
    if (rightImage) {
      rightImage.style.top = newBottomPosition;
      rightImage.style.transform = 'translateY(-' + newBottomPosition + ')';
    }
  }
}

// Attach scroll event listener to window
window.addEventListener('scroll', onScroll);

// Call onScroll initially in case the element is already in view
onScroll();